import { adminApi } from './api'

export type MediaUploadResult = {
  url: string
  storedPath: string
  relativePath?: string
}

export type MediaPurpose = 'default' | 'logo'

/** Upload an image via admin → Media CDN (server-side). */
export async function uploadAdminMedia(
  file: File,
  purpose: MediaPurpose = 'default'
): Promise<MediaUploadResult> {
  const fd = new FormData()
  fd.set('file', file)
  if (purpose !== 'default') fd.set('purpose', purpose)
  const q = purpose !== 'default' ? `?purpose=${encodeURIComponent(purpose)}` : ''
  const { res, data } = await adminApi<{
    success?: boolean
    message?: string
    url?: string
    storedPath?: string
    relativePath?: string
  }>(`/api/admin/website/media${q}`, { method: 'POST', formData: fd })

  if (!res.ok || !data.url) {
    throw new Error(data.message || 'Image upload failed')
  }
  return {
    url: data.url,
    storedPath: data.storedPath || data.relativePath || data.url,
    relativePath: data.relativePath,
  }
}

/** Suggested upload sizes shown in CMS image fields. */
export const IMAGE_SIZE_HINTS = {
  logo: '800 × 400 px PNG (transparent). Logo centered; we auto-pad to this canvas.',
  team: '800 × 1000 px (4:5) JPG/PNG. Face near the top; min 600 × 750.',
  cover: '1600 × 900 px (16:9) JPG/WebP. Ideal 1920 × 1080; avoid text near edges.',
  editor: '1200–1600 px wide JPG/PNG/WebP. Keep under 2 MB for fast pages.',
} as const
